<div class="wrapper">
  <label [for]="id" class="label-switch">{{ label }}</label>
  <label class="switch">
    <input #input type="checkbox" [id]="id" [(ngModel)]="value" (ngModelChange)="updateChanges()">
    <span class="slider-switch" [ngClass]="{'primary': primary}"></span>
  </label>
</div>
